<template>
  <div class="flex items-center">
    <span class="text-gray-700 font-medium py-2 sm:text-sm">{{
      t("admin.tasks.recurring.every")
    }}</span>
    <interval
      @change="handleIntervalChanged"
      class="ml-3"
      :value="freqInterval"
      :limit="30"
      :disabled="disabled"
    />
    <span class="ml-3 text-gray-700 font-medium sm:text-sm">{{
      t("admin.tasks.recurring.day_days")
    }}</span>
  </div>
</template>

<script setup>
import { RRule } from "rrule";
import Interval from "@/Tailwind/Components/RRule/Components/Interval";
import { useI18n } from "vue-i18n";
import { computed, defineProps, defineEmits, onMounted, ref } from "vue";

const { t } = useI18n();

const emit = defineEmits(["change"]);

const props = defineProps({
  interval: {
    type: Number,
    default: 1,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const freqInterval = ref(props.interval);

const rule = computed(() => {
  return new RRule({
    freq: RRule.DAILY,
    interval: freqInterval.value,
  });
});

onMounted(() => {
  emit("change", rule);
});

function handleIntervalChanged(v) {
  freqInterval.value = v;
  emit("change", rule);
}
</script>
